import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { PersonItem, Person } from '../models';

export class PersonApi extends ApiModule {
  protected endpoint = '/person';

  public async pagePersons(params: any) {
    return this.api.post<PaginatedResponseData<PersonItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadPersonDetails(id: number) {
    return this.api.get<Person>(`${this.endpoint}?id=${id}`);
  }

  public loadPersonByLocation(educationLocationId: number, tutorReportId?: number) {
    if (tutorReportId) {
      return this.api.get<Person[]>(
        `${this.endpoint}/search-by-location-and-report?educationLocationId=${educationLocationId}&tutorReportId=${tutorReportId}`
      );
    }
    return this.api.get<Person[]>(`${this.endpoint}/search-by-location?educationLocationId=${educationLocationId}`);

    // return this.api.get<Person[]>(`${this.endpoint}/search-by-location?educationLocationId=${educationLocationId}`);
  }

  public savePerson(params: any) {
    return this.api.post<any, Person>(`${this.endpoint}`, {
      ...params
    });
  }

  public deletePerson(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }
}
